"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeInput = void 0;
const DOM_1 = require("../utils/DOM");
class CodeInput {
    static init(params) {
        const triggers = DOM_1.DOM.Parser.getHtmlElements('codeInput');
        for (let i = 0; i < triggers.length; i++) {
            const trigger = triggers[i];
            this.initializeElement(trigger, params);
        }
    }
    static showProgress(codeInputElement) {
        codeInputElement.classList.add('busy');
        const inputs = DOM_1.DOM.Parser.getHtmlElementsByQuery('input', codeInputElement);
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].disabled = true;
        }
    }
    static hideProgress(codeInputElement) {
        codeInputElement.classList.remove('busy');
        const inputs = DOM_1.DOM.Parser.getHtmlElementsByQuery('input', codeInputElement);
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].disabled = false;
        }
    }
    static initializeElement(trigger, params) {
        const inputElements = DOM_1.DOM.Parser.getHtmlElements('codeInput-input', trigger);
        const firstInputElement = inputElements[0];
        firstInputElement.focus();
        for (let i = 0; i < inputElements.length; i++) {
            const input = inputElements[i];
            input.addEventListener('keydown', (e) => {
                if (e.keyCode === 8 && e.target.value === '')
                    inputElements[Math.max(0, i - 1)].focus();
            });
            input.addEventListener('input', (e) => {
                const [first, ...rest] = e.target.value;
                e.target.value = first ?? '';
                const lastInputBox = i === inputElements.length - 1;
                const didInsertContent = first !== undefined;
                if (didInsertContent && !lastInputBox) {
                    inputElements[i + 1].focus();
                    inputElements[i + 1].value = rest.join('');
                    inputElements[i + 1].dispatchEvent(new Event('input'));
                }
                else if (lastInputBox) {
                    let finalValue = '';
                    for (let j = 0; j < inputElements.length; j++) {
                        const indexInputValue = inputElements[j].value.toString().trim();
                        if (indexInputValue.length === 0) {
                            return;
                        }
                        finalValue += indexInputValue;
                    }
                    params.finishCallback(finalValue);
                }
            });
        }
    }
}
exports.CodeInput = CodeInput;
